import { Modal, Button } from "react-bootstrap";

export const ErrorModal = ({ showErrorModal, setShowErrorModal, error }) => {
    const handleErrorModalClose = () => setShowErrorModal(false)

    return (
        <Modal show={showErrorModal} onHide={handleErrorModalClose}>
            <Modal.Header closeButton>
                <Modal.Title>Erro!</Modal.Title>
            </Modal.Header>
            <Modal.Body>{error}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleErrorModalClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
